export default "__VITE_ASSET__LhEECHlL__"